import '@pwabuilder/pwaupdate';
import '@pwabuilder/pwainstall';
import Cookies from 'js-cookie';

export default (el) => {
    const cookieName = '_app-install';
    let installAppNavItem = document.getElementById('install-app-nav-item');

    function updateOnlineStatus(event) {
        if (navigator.onLine) {
            document.documentElement.classList.remove('-is-offline');
        } else {
            document.documentElement.classList.add('-is-offline');
        }
    }

    window.addEventListener('online',  updateOnlineStatus);
    window.addEventListener('offline', updateOnlineStatus);

    let pwaInstallElement = document.querySelector('pwa-install');
    if (!pwaInstallElement.getInstalledStatus() && matchMedia('(max-width: 800px)').matches) {
        // Use interval to make sure the manifest is loaded
        let pwaInterval = setInterval(function() {
            if (pwaInstallElement.shouldShowInstall()) {
                // Show install app nav item
                if (installAppNavItem) {
                    installAppNavItem.parentNode.parentNode.classList.remove('-hidden');
                }

                if (!Cookies.get(cookieName)) {
                    // Show popup only once
                    pwaInstallElement.openPrompt();
                    setTimeout(function() {
                        document.querySelector('pwa-install').shadowRoot.querySelector('img').style.background = '#fff';
                    }, 1);

                    Cookies.set(cookieName, 1, {
                        expires: 90,
                        sameSite: 'Strict',
                    });
                }

                clearInterval(pwaInterval);
            }
        }, 1000);
    }

    if (installAppNavItem) {
        installAppNavItem.addEventListener('click', e => {
            e.preventDefault();
            pwaInstallElement.openPrompt();
            setTimeout(function() {
                document.querySelector('pwa-install').shadowRoot.querySelector('img').style.background = '#fff';
            }, 1);
        });
    }
}
